const website = {
  link: "https://zorotopup.com",
  name: "Zozo's Domain",
  mail: "zorotopup6@gmail.com",
  support: "+91 9402831766 / 9707315156",
  instagram: "https://www.instagram.com/zoros_domain",
  facebook: "https://www.facebook.com/profile.php?id=61575252140358",
  whatsapp: "https://wa.me/919707315156",
  whatsappchannel: "",
};

export default website;
